import CommonAvatar from "@/modules/common/components/ui-kit/common-avatar";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { Box, Typography, useTheme } from "@mui/material";
import { PhoneIcon } from "lucide-react";
import { useContext } from "react";

export const PartnerInfo = () => {
  const { lead } = useContext(LeadPageContext);
  const theme = useTheme();

  if (!lead?.data.lead.partner) {
    return null;
  }

  const partnerName = lead?.data.lead.partner?.name;
  const phone = lead?.data.lead.partner?.phone;
  const organizationName = lead?.data.lead.partner?.partnerOrganization?.name;

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        padding: theme.nawy.spacing.xs,
        borderRadius: theme.nawy.radius.xl,
        border: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
        display: "flex",
        flexDirection: "column",
        gap: theme.nawy.spacing.xs,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: theme.nawy.spacing.xs,
          width: "100%",
        }}
      >
        <CommonAvatar
          name={partnerName}
          color={theme.nawy.colors.primitives.blue[500]}
        />

        <Box sx={{ display: "flex", flexDirection: "column" }}>
          {organizationName && (
            <Typography
              sx={{
                color: theme.nawy.colors.primitives.grey[700],
                ...theme.nawy.typography.english.variants.body.sm.regular,
              }}
            >
              {organizationName}
            </Typography>
          )}
          {partnerName && (
            <Typography
              sx={{
                color: theme.nawy.colors.primitives.grey[900],
                ...theme.nawy.typography.english.variants.body.md.regular,
              }}
            >
              {partnerName}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Phone Box */}
      {phone && (
        <Box
          sx={{
            bgcolor: theme.nawy.colors.primitives.white[200],
            borderRadius: theme.nawy.radius.lg,
            padding: theme.nawy.spacing.xs,
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: theme.nawy.spacing.xs,
          }}
        >
          <PhoneIcon
            width={14}
            height={14}
            color={theme.nawy.colors.primitives.grey[900]}
          />
          <Typography
            sx={{
              color: theme.nawy.colors.semantic.text.primary,
              ...theme.nawy.typography.english.variants.body.sm.regular,
            }}
          >
            {phone}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
